import { AnalyticsEvent, AnalyticsManager } from '@oy/analytics';
import { ACCOUNT_STATEMENT_STATUSES } from 'src/constants';
import { useProductMap, useStatusMap } from 'src/hooks';
import { formatDateToString } from 'src/utilities//helpers';
import { InitialFilterDataProps } from '../types';

export const useAccountStatementTrack = () => {
  const { txProducts } = useProductMap();
  const { getStatuses } = useStatusMap();

  const trackCustomColumn = () => {
    AnalyticsManager.instance().track(AnalyticsEvent.click_custom_column);
  };

  const trackClickFilter = (type: string) => {
    AnalyticsManager.instance().track(AnalyticsEvent.click_filter, {
      type,
    });
  };

  const trackExportReport = (exportType: string) => {
    AnalyticsManager.instance().track(AnalyticsEvent.acctstatement_export, {
      file_type: exportType,
    });
  };

  const trackClickInfoDetail = (type: string) => {
    AnalyticsManager.instance().track(AnalyticsEvent.click_information_detail, {
      type,
    });
  };

  const trackUpgradeAccountTooltipAction = (type: 'skip' | 'next') => {
    AnalyticsManager.instance().track(AnalyticsEvent.upgrade_account_tooltip, {
      action: type,
    });
  };
  const trackClickOverbooking = () => {
    AnalyticsManager.instance().track(AnalyticsEvent.click_overbooking_tab);
  };

  const trackLearnMoreOverbooking = () => {
    AnalyticsManager.instance().track(
      AnalyticsEvent.click_button_learn_more_overbooking,
    );
  };
  const trackClickHowToTopup = () => {
    AnalyticsManager.instance().track(AnalyticsEvent.click_how_to_top_up);
  };

  const trackDataFilter = (data: InitialFilterDataProps) => {
    AnalyticsManager.instance().track(AnalyticsEvent.acctstatement_filter, {
      start_date: data.start_date && formatDateToString(data.start_date),
      end_date: data.end_date && formatDateToString(data.end_date),
      product: txProducts.find(product => product.value === data.tx_product)
        ?.value,
      status: getStatuses(ACCOUNT_STATEMENT_STATUSES).find(
        status => status.value === data.tx_status,
      )?.value,
    });
  };

  const trackMamClickBatch = (type: string) => {
    AnalyticsManager.instance().track(
      type === 'check_all'
        ? AnalyticsEvent.mam_click_check_all_request
        : AnalyticsEvent.mam_click_reject_all_request,
    );
  };

  const trackMamClickSingle = (type: string, proposed_parent: string) => {
    AnalyticsManager.instance().track(
      type === 'accept'
        ? AnalyticsEvent.mam_click_accept_request
        : AnalyticsEvent.mam_click_reject_request,
      {
        proposed_parent,
      },
    );
  };

  const trackWithdrawal = (withdrawalType: string, env: string) => {
    AnalyticsManager.instance().track(AnalyticsEvent.acctstatement_withdraw, {
      withdrawal_type: withdrawalType,
      env,
    });
  };

  const trackClickWithdraw = (env: string) => {
    AnalyticsManager.instance().track(AnalyticsEvent.click_withdraw, {
      env,
    });
  };

  const trackSubmitManualTopup = () => {
    AnalyticsManager.instance().track(
      AnalyticsEvent.click_submit_now_manual_topup,
    );
  };

  const trackClickTopUpUniqueCode = () => {
    AnalyticsManager.instance().track(AnalyticsEvent.click_top_up_unique_code);
  };

  const trackInputAmount = () => {
    AnalyticsManager.instance().track(AnalyticsEvent.input_amount);
  };

  const trackClickSubmitAmount = () => {
    AnalyticsManager.instance().track(
      AnalyticsEvent.click_submit_amount_bca_topup,
    );
  };

  const trackClickCopyUniqueAmount = () => {
    AnalyticsManager.instance().track(AnalyticsEvent.click_copy_unique_amount);
  };

  const trackClickCopyBcaAccountNumber = () => {
    AnalyticsManager.instance().track(
      AnalyticsEvent.click_copy_bca_account_number,
    );
  };

  return {
    trackClickFilter,
    trackClickHowToTopup,
    trackClickInfoDetail,
    trackClickOverbooking,
    trackClickWithdraw,
    trackCustomColumn,
    trackDataFilter,
    trackExportReport,
    trackLearnMoreOverbooking,
    trackMamClickBatch,
    trackMamClickSingle,
    trackSubmitManualTopup,
    trackUpgradeAccountTooltipAction,
    trackWithdrawal,
    trackClickCopyBcaAccountNumber,
    trackClickCopyUniqueAmount,
    trackClickTopUpUniqueCode,
    trackInputAmount,
    trackClickSubmitAmount,
  };
};
